exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body span[data-v-3ec809fc]{vertical-align:inherit}.summary-highcharts-container[data-v-3ec809fc],.summary-highcharts-container>*[data-v-3ec809fc]{position:relative;height:100%;width:100%}", ""]);

// exports
